import React from 'react';
import PropTypes from 'prop-types';
import { MemoryChatSelector } from './MemoryChatSelector';
import { MemoryChatThread } from './MemoryChatThread';
import { Loader } from '../../Loader';
import { Button } from '../../Button';
import styles from './MemoryChat.css';

function MemoryChat({
    chapters,
    activeChapter,
    onSelectChapter,
    messages,
    isLoadingMessages,
    isChatError,
    onRetry,
    isAssistantTyping,
    isChatFinished,
    sendErrorMessage,
    onSendMessage
}) {
    const renderThread = () => {
        if (isLoadingMessages) {
            return (
                <div className={styles.loaderWrapper}>
                    <Loader variant='secondary' />
                </div>
            );
        }

        if (isChatError) {
            return (
                <div className={styles.loaderWrapper}>
                    <div className={styles.errorState}>
                        <p className={styles.errorMessage}>Something went wrong loading this chapter.</p>
                        <Button
                            label='Try again'
                            type='primary'
                            onClick={onRetry}
                            buttonProps={{ type: 'button' }}
                        />
                    </div>
                </div>
            );
        }

        return (
            <MemoryChatThread
                activeChapter={activeChapter}
                messages={messages}
                isAssistantTyping={isAssistantTyping}
                isChatFinished={isChatFinished}
                sendErrorMessage={sendErrorMessage}
                onSendMessage={onSendMessage}
            />
        );
    };

    return (
        <section className={styles.root}>
            <MemoryChatSelector
                chapters={chapters}
                activeChapter={activeChapter}
                onSelect={onSelectChapter}
            />

            {renderThread()}
        </section>
    );
}

MemoryChat.propTypes = {
    chapters: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        answerCount: PropTypes.number.isRequired
    })).isRequired,
    activeChapter: PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        answerCount: PropTypes.number.isRequired,
        answersUntilMemory: PropTypes.number.isRequired,
        isMemoryUnlocked: PropTypes.bool.isRequired,
        isMemoryPending: PropTypes.bool.isRequired
    }).isRequired,
    onSelectChapter: PropTypes.func.isRequired,
    messages: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        author: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    })).isRequired,
    isLoadingMessages: PropTypes.bool.isRequired,
    isChatError: PropTypes.bool.isRequired,
    onRetry: PropTypes.func.isRequired,
    isAssistantTyping: PropTypes.bool.isRequired,
    isChatFinished: PropTypes.bool.isRequired,
    sendErrorMessage: PropTypes.string,
    onSendMessage: PropTypes.func.isRequired
};

MemoryChat.defaultProps = {
    sendErrorMessage: null
};

export {
    MemoryChat
};
